import { cloudfrontVideo } from "./cloudfront";

export const handleClick = (e) => {
  e.preventDefault();
  // eslint-disable-next-line no-empty
  if (e.button === 2) {
  }
};
export const getMainVideo = ({ main_video }) => {
  return cloudfrontVideo(main_video);
};
